<template>
    <div id="step5">
        <a-result v-if="isResult" status="warning" title="Please make sure data valid at previous step."></a-result>
        <a-row v-else>
            <a-row style="padding: 6px 15px 0 15px ;">
                <a-row style="font-size: 13px;font-weight: 800;" class="sbxs mt4" type="flex" justify="space-between">
                    <a-col>
                        <a-icon type="caret-down" />Order
                    </a-col>
                </a-row>

                <a-row class="step5_Order">
                    <a-row type="flex">
                        <a-col :span="6">
                            <a-col class="orderTitle">Order No.:</a-col>
                            <a-col class="orderValue">{{initCloseValue.orderNo}}</a-col>
                        </a-col>
                        <a-col :span="6">
                            <a-col class="orderTitle">Order Type:</a-col>
                            <a-col class="orderValue">{{initCloseValue.orderType}}</a-col>
                        </a-col>
                        <a-col :span="6">
                            <a-col class="orderTitle">Delivery Mode:</a-col>
                            <a-col class="orderValue">{{initCloseValue.deliveryMode}}</a-col>
                        </a-col>
                        <a-col :span="6">
                            <a-col class="orderTitle">Delivery Date:</a-col>
                            <a-col class="orderValue">{{initCloseValue.etd}}</a-col>
                        </a-col>
                    </a-row>

                    <a-row style="margin-top: 10px">
                        <a-col :span="18">
                            <a-col class="orderTitle">Delivery Address:</a-col>
                            <a-col class="orderValue">
                                {{initCloseValue.address1 == null ? '' : initCloseValue.address1 + ','}}
                                {{initCloseValue.address2 == null ? '' : initCloseValue.address2 + ','}}
                                {{initCloseValue.address3 == null ? '' : initCloseValue.address3 + ','}}
                                {{initCloseValue.address4 == null ? '' : initCloseValue.address4 }}
                            </a-col>
                            <a-col class="orderValue">
                                {{initCloseValue.city == null ? '' : initCloseValue.city + ','}}
                                {{initCloseValue.state == null ? '' : initCloseValue.state + ','}}
                                {{initCloseValue.country == null ? '' : initCloseValue.country}}
                            </a-col>
                        </a-col>
                        <a-col :span="4" v-if="false">
                            <a-col class="orderTitle">Courier:</a-col>
                            <a-col class="orderValue">{{initCloseValue.courier}}</a-col>
                        </a-col>

                    </a-row>
                    <a-row type="flex" justify="start">
                        <a-col class="orderTitle">Phone: </a-col>
                        <a-col class="orderValue  ml4">{{initCloseValue.phone}}</a-col>
                    </a-row>

                    <a-row type="flex" justify="start">
                        <a-col>
                            <a-row type="flex" justify="start">
                                <a-col class="orderTitle">Contact:</a-col>
                                <a-col class="orderValue ml4">{{initCloseValue.contact}}</a-col>
                            </a-row>
                        </a-col>
                    </a-row>

                    <a-row type="flex" style="margin-top: 8px">
                        <a-col :span="10">
                            <a-col class="orderTitle">VAS Instruction:</a-col>
                            <a-col class="orderValue" v-for="item in vasInstructionArr">{{item}}</a-col>
                        </a-col>
                        <a-col :span="10">
                            <a-col class="orderTitle">Remark:</a-col>
                            <a-col class="orderValue" v-for="item in remarkArr">{{item}}</a-col>
                        </a-col>
                    </a-row>
                </a-row>
            </a-row>
            <a-row>
                <a-row  type="flex" justify="space-between" class="paddingLeftRight" style="color: #ababab;font-size: 14px;margin: 10px 0 10px 15px; font-weight: 800;">
                    <a-col>Order Detail</a-col>
                    <a-col>Total: {{step5Obj == null ? 0:step5Obj==undefined ? 0 : step5Obj.length}} records</a-col>
                </a-row>
                <a-row  style="height: 53vh;overflow-y: auto">
                    <a-row type="flex" class="list_Liquor" v-for="(item, index) in step5Obj">
                        <a-col class="sbxs">
                            <img v-if="item.photoBase != null" :src="item.photoBase" width="138" height="138">
                            <img  src="../../../../assets/img/nophoto.jpg"  width="138" height="138" v-else>
                        </a-col>

                        <a-col class="list_Liquor_detail">
                            <a-row type="flex" justify="space-between">
                                <a-col class="list_Liquor_left">
                                    <a-col class='list_Liquor_title'>{{item.wineName == '' ? '.....' : item.wineName}}</a-col>
                                    <a-col style="height: 33px">{{item.remark}}</a-col>
                                    <a-row type="flex" justify="start" style="color: #707070;font-size: 12px;">
                                        <a-col>{{item.year}}</a-col>
                                        <a-col class="ml4">{{item.itemSize}}</a-col>
                                        <a-col class="ml4">{{item.region}}</a-col>
                                    </a-row>
                                    <a-col style="color: #707070;font-size: 12px;margin: 4px 0 ">Package: {{item.packageQty}}</a-col>
                                    <a-col style="color: #707070;font-size: 12px;">Received On: {{moment(item.receivedTime).format("YYYY-MM-DD")}}</a-col>
                                </a-col>
                                <a-col class="list_Liquor_Right">
                                    <a-col style="text-align: left;">
                                        <a-col style="font-size: 13px;">Order Qty</a-col>
                                            <a-input-number
                                                disabled
                                                @blur="orderQtyBlur(item)"
                                                :formatter="value => `$ ${value}`.replace(/^(0+)|[^\d]/g, '')"
                                                :parser="value => value.replace(/^(0+)|[^\d]/g, '')"
                                                ref="orderQtyinputNumberRefs" :max="parseInt(item.availableQty)" :min="0"  size="small" style="width: 60px;" v-model="item.orderQty" />
                                    </a-col>
                                    <a-col style="margin-top: 50px;" class="sbxs" v-if="false">
                                        <a-col style="margin-top: 50px;" class="sbxs">
                                            <a-popconfirm
                                                    title="Are you sure delete item?"
                                                    ok-text="Yes"
                                                    cancel-text="No"
                                                    @confirm="liqutorDeleteStep5(item)"
                                            >
                                                <img src="../../../../assets/img/Liqutor-delete.png" width="30" height="30">
                                            </a-popconfirm>
                                        </a-col>
                                    </a-col>
                                </a-col>
                            </a-row>
                        </a-col>

                    </a-row>
                </a-row>
            </a-row>
        </a-row>
        <div
                :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              zIndex: 1,}">
            <a-button @click='goTypeClick("Back")' class="fl" type="primary" size="small"><img src="../../../../assets/img/Liqutor-left.png" width="13" height="12" class="mr4">Previous</a-button>
            <a-button :disabled="isResult" @click='goTypeClick("Confirm")' class="fr" type="primary" size="small"><img src="../../../../assets/img/Liqutor-arrow-right.png" width="13" height="12" class="mr4">Confirm</a-button>
        </div>
    </div>
</template>
<script>
    import moment from "moment";
    import { mapState } from "vuex";
    import  ajax from '../../../../api/ajax'
    import  api from '../../../../api/url'
    export default{
        props:{
            sellLiquor: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            initCloseValue:{
                type: Object,
                default: function() {
                    return {};
                }
            }
        },
        computed: {
            ...mapState(["whsCode"]),
        },
        watch:{
            initCloseValue: function(val){
                this.step5Obj  = val.invTempDetailList
               
                if(this.step5Obj == null || this.step5Obj == undefined){
                    return
                }
                if(this.step5Obj.length > 0){
                    this.isResult = false
                }else{
                    this.isResult = true
                }
                if(this.initCloseValue.consignee  && this.initCloseValue.phone && (this.initCloseValue.address1 || this.initCloseValue.address3) && this.initCloseValue.orderNo){ //
                    this.isResult = false
                }else{
                    this.isResult = true
                }

                //  console.info(this.isResult)
                // console.info(this.initCloseValue)
                   
                this.initCloseValue.delieveryDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                if(val.vasInstruction && val.vasInstruction != ''){
                    this.vasInstructionArr = this.initCloseValue.vasInstruction.split('\n')
                }else{
                    this.vasInstructionArr = []
                }
                if(val.remark && val.remark != ''){
                    this.remarkArr = this.initCloseValue.remark.split('\n')
                }else{
                    this.remarkArr = []
                }
            }
        },
        created(){
            this.step5Obj = this.initCloseValue.invTempDetailList
            if(this.initCloseValue.consignee  && this.initCloseValue.phone && (this.initCloseValue.address1 || this.initCloseValue.address3) && this.initCloseValue.orderNo){ //
                    this.isResult = false
                }else{
                    this.isResult = true
                }
            this.initCloseValue.delieveryDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            if(this.initCloseValue.vasInstruction && this.initCloseValue.vasInstruction != ''){
                this.vasInstructionArr = this.initCloseValue.vasInstruction.split('\n')
            }else{
                this.vasInstructionArr = []
            }
            if(this.initCloseValue.remark && this.initCloseValue.remark != ''){
                this.remarkArr = this.initCloseValue.remark.split('\n')
            }else{
                this.remarkArr = []
            }
        },
        data(){
            return{
                step5Obj: [],
                isResult: false,
                vasInstructionArr: [],
                remarkArr: []
            }
        },
        methods:{
            orderQtyBlur(val){
                this.orderQtySave(val)
            },
            orderQtySave(item){
                if(item.orderQty > item.availableQty){
                    this.$message.warning('Order Qty more than Available Qty: ' + item.availableQty);
                    return
                }
                let arr = [
                    {
                        "itemSize": item.itemSize,
                        "orderQty": item.orderQty,
                        "packageQty":item.packageQty,
                        "region": item.region,
                        "sku": item.sku,
                        "wineName": item.wineName,
                        "year": item.year,
                        "skuCode": item.skuCode,
                        "receivedTime": moment(item.receivedTime).format("YYYYMMDD")
                    }
                ]
                let params = {
                    soDetail: arr,
                    currentStep: '5'
                }
                ajax.post(api.INVWINEADDTEMPORDER,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                    }else{
                        this.$message.warning(res.msg);
                    }
                })
            },
            moment,
            liqutorDeleteStep5(item){
                for(let i in this.step5Obj){
                    if(this.step5Obj[i] == item){
                        this.step5Obj.splice(i, 1)
                    }
                }
                let params ={
                    deleteFlag: 0,
                    currentStep: '5',
                    soDetail: [
                        {
                            "itemSize": item.itemSize,
                            "orderQty": item.orderQty,
                            "packageQty": item.packageQty,
                            "region": item.region,
                            "sku": item.sku,
                            "wineName": item.wineName,
                            "year": item.year,
                            "skuCode": item.skuCode,
                            "receivedTime": moment(item.receivedTime).format("YYYYMMDD")
                        }
                    ]
                }
                ajax.post(api.INVWINEADDTEMPORDER,params).then(res=>{
                    if(res.code == 200){
                        if(this.step5Obj.length == 0){
                            this.$emit('goType','step2ResetBack')
                        }
                    }else{
                        this.$message.warning(res.msg);
                    }
                })
            },
            OrderQtyClick(v,item,index){
                if(v.key == 10){
                    item.orderQtyFlag = false
                    this.$nextTick(()=>{
                        let input = this.$refs.orderQtyinputNumberRefs[index].$el.children[1].children[0]
                        input.focus()
                        input.select()
                    })
                }
                this.orderQtySave(item)
                item.orderQty = v.key
            },
            timeFliter(time){
                let s = '';
                let hour = time.split(':')[0];
                let min = time.split(':')[1];
                let sec = time.split(':')[2];
                if(sec != undefined){
                    s = Number(hour*3600) + Number(min*60) + Number(sec);
                }else{
                    s = Number(hour*3600) + Number(min*60)
                }
                return s
            },
            goTypeClick(type){
                if(type == 'Confirm'){
                    if(this.initCloseValue.isUrgent == 'Y'){
                        let td=new Date();
                        td=new Date(td.getFullYear(),td.getMonth(),td.getDate());
                        let od=new Date(this.initCloseValue.etd);
                        od=new Date(od.getFullYear(),od.getMonth(),od.getDate());
                        let xc=(od-td)/1000/60/60/24;
                        if(xc<2){
                            ajax.post(api.INVWINEDROPDOWN,{code: 'SO_URGENT_TIME'}).then(res=>{
                                let d = new Date();
                                let my_hours=d.getHours();
                                let my_minutes=d.getMinutes();
                                let my_seconds=d.getSeconds();
                                let targetTime = my_hours+ ':'+ my_minutes + ':'+ my_seconds

                                let data = res.data
                                if(data.length > 0){
                                    let str = res.data[0].code
                                    if(this.timeFliter(targetTime) > this.timeFliter(str) && this.timeFliter(targetTime) != this.timeFliter(str)){
                                        this.$message.success('This order changed to Urgent type')
                                        this.submitFrom()
                                    }else{
                                        this.$emit('goType','Back')
                                    }
                                }else{
                                    this.$emit('goType','Back')
                                }
                            })
                        }else{
                            this.$emit('goType','Back')
                        }
                    }else{
                        this.submitFrom()
                    }

                }else{
                    this.$emit('goType',type)
                }
            },
            submitFrom(){
                let params ={
                    "zip": this.initCloseValue.zip,
                    "etd": this.initCloseValue.etd,
                    "currentStep": '5',
                    "address1": this.initCloseValue.address1,
                    "address2": this.initCloseValue.address2,
                    "address3": this.initCloseValue.address3,
                    "address4": this.initCloseValue.address4,
                    "city": this.initCloseValue.city,
                    "consignee": this.initCloseValue.consignee,
                    "country": this.initCloseValue.country,
                    "delieveryDate": moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                    "delieveryMode": this.initCloseValue.deliveryMode,
                    "email": this.initCloseValue.email,
                    "orderNo": this.initCloseValue.orderNo,
                    "orderType": this.initCloseValue.orderType,
                    "remarks": this.initCloseValue.remark,
                    "soDetail": this.step5Obj,
                    "state": this.initCloseValue.state,
                    "tel": this.initCloseValue.phone,
                    "vasInstruction": this.initCloseValue.vasInstruction,
                    "warehouseCode": this.whsCode,
                    "onHold":this.initCloseValue.onHold,
                    "contact":this.initCloseValue.contact
                }
                let that = this
                this.$confirm({
                    title: 'Are you sure to confirm?',
                    okText: 'Yes',
                    okType: 'danger',
                    cancelText: 'No',
                    onOk() {
                        ajax.post(api.INVWINESAVEORDER,params).then(res=>{
                            if(res.code == 200){
                                that.$message.success(res.msg);
                                that.$emit('goType','close')
                            }else{
                                that.$message.warning(res.msg);
                            }
                        })
                    },
                    onCancel() {

                    },
                })
            }
        }
    }
</script>
<style lang="less">
#step5{
    .step5_Order{
        border: 1px solid #929292;
        background: #fafafa;
        padding: 8px;
        .orderTitle{
            color: #707070;
            font-size:12px;
            font-weight: 800;
        }
        .orderValue{
            color: #707070;
            font-size:12px;
        }
    }
    .list_Liquor{
        border-bottom:1px solid #b8b8b8;
        padding:6px 4px 6px 0;
        .list_Liquor_detail{
            flex: 1;
            margin-left: 10px;
            margin-top:8px;
            .list_Liquor_left{
                .list_Liquor_title{
                    color: #698bdc;
                    font-weight: 800;
                    font-size: 12px;
                    margin-bottom: 10px;
                }
            }
            .list_Liquor_Right{
                color: #707070;
                text-align: right;
                .list_Liquor_Right_T{
                    margin-bottom: 32px;
                }
            }
        }
    }
}
</style>